export default class FormacaoCursoEdicaoController {
    constructor($q, $state, $http, UIService, FormacaoService, FormacaoEdicao, FormacaoEdicaoAvaliacao, FormacaoInscricao, FormacaoEdicaoLeccionacao, FormacaoLocal, FormacaoEdicaoEstado, FormacaoModalidade, FormacaoEdicaoAnexo, FormacaoEdicaoRegime, FormacaoInscricaoEstado, FormacaoFormando) {
        this.$q = $q;
        this.$state = $state;
        this.$http = $http;
        this.UI = UIService;
        this.FormacaoService = FormacaoService;
        this.FormacaoEdicao = FormacaoEdicao;
        this.FormacaoEdicaoAvaliacao = FormacaoEdicaoAvaliacao;
        this.FormacaoInscricao = FormacaoInscricao;
        this.FormacaoEdicaoLeccionacao = FormacaoEdicaoLeccionacao;
        this.FormacaoLocal = FormacaoLocal;
        this.FormacaoEdicaoEstado = FormacaoEdicaoEstado;
        this.FormacaoModalidade = FormacaoModalidade;
        this.FormacaoEdicaoAnexo = FormacaoEdicaoAnexo;
        this.FormacaoEdicaoRegime = FormacaoEdicaoRegime;
        this.FormacaoInscricaoEstado = FormacaoInscricaoEstado;
        this.FormacaoFormando = FormacaoFormando;
        this.id = $state.params.id;
        this.ed = $state.params.ed;
        // Using this to reduce html generated by tabset, since all content is equals but only filtered
        this.inscritosEstado = 1;
        // Redirect if something is not defined
        if (!this.id) {
            this.$state.go('app.formacao.cursos.list');
        }
        else {
            if (!this.ed) {
                this.$state.go('app.formacao.cursos.details({id:' + this.id + '})');
            }
        }
        this.hasLoaded = false;
        // For modal
        this.simnao = [{ designacao: "Sim", value: 1 }, { designacao: "Não", value: 0 }];
        this.loadData();
    }
    loadData = () => {
        this.hasLoaded = false;
        this.FormacaoEdicao.findOne({
            filter: {
                where: {
                    id: this.ed,
                    cursoId: this.id
                },
                include: [
                    {
                        relation: 'local',
                        scope: {
                            where: {
                                active: true
                            }
                        }
                    },
                    {
                        relation: 'tipo',
                        scope: {
                            where: {
                                active: true
                            }
                        }
                    }, 'estado', 'empresa',
                    {
                        relation: 'curso',
                        scope: {
                            include: {
                                relation: 'areaCategoria',
                                scope: {
                                    include: 'area'
                                }
                            }
                        }
                    },
                    {
                        relation: 'avaliacoes',
                        scope: {
                            include: {
                                relation: 'formador',
                                scope: {
                                    include: {
                                        relation: 'leccionacoes',
                                        scope: {
                                            where: {
                                                edicaoId: this.ed
                                            },
                                            include: 'modulo'
                                        }
                                    }
                                }
                            }
                        }
                    },
                    {
                        relation: 'anexos',
                        scope: {
                            where: {
                                active: 1
                            },
                            include: 'TipoAnexo'
                        }
                    },
                    {
                        relation: 'inscricoes',
                        scope: {
                            include: ['formando', 'pagamento', {
                                    relation: 'inscricaoEmpresa',
                                    scope: {
                                        include: 'empresa'
                                    }
                                }]
                        }
                    },
                    'modalidade', 'regime'
                ]
            }
        }).$promise.then(res => {
            if (res) {
                this.edicao = res;
                this.docs = [];
                res.anexos.forEach(doc => {
                    this.$http.get('/api/Upload/for/files/' + doc.nome).then((result) => {
                        if (result.data != null && !result.data.hasOwnProperty('error')) {
                            this.docs.push({
                                info: doc,
                                nome: result.data.name,
                                TipoAnexo: doc.TipoAnexo,
                                atime: result.data.atime,
                                mtime: result.data.mtime,
                                fileSize: result.data.size
                            });
                        }
                    }, (err) => {
                        console.log(err);
                    });
                });
                if (this.edicao.inscricoes && this.edicao.inscricoes.length > 0) {
                    // Sort by formando name (localeCompare so we can deal with accented chars)
                    this.edicao.inscricoes.sort((a, b) => a.formando.nome.localeCompare(b.formando.nome));
                }
                this.hasLoaded = true;
            }
            else {
                this.UI.addToast('Ocorreu um erro a carregar edição');
                this.$state.go('app.formacao.cursos.details({id:' + this.id + '})');
            }
        }).catch(() => {
            this.UI.addToast('Ocorreu um erro a carregar edição');
            this.$state.go('app.formacao.cursos.details({id:' + this.id + '})');
        });
    };
    getAreaFormacao = () => {
        if (this.hasLoaded) {
            if (angular.isDefined(this.edicao.curso.areaCategoria)) {
                return "<p>" + this.edicao.curso.areaCategoria.designacao + "</p><p class='hidden-sm'>(" + this.edicao.curso.areaCategoria.area.codigo + ") " + this.edicao.curso.areaCategoria.area.designacao + "</p>";
            }
            else {
                return "<p>N/D</p>";
            }
        }
        else {
            return "<p>N/D</p>";
        }
    };
    getFormandosEstado = estado => {
        let total = 0;
        this.edicao.inscricoes.forEach(i => {
            if (i.formando)
                i.formando.name = i.formando.nome;
            if (i.estadoId === estado)
                total++;
        });
        return total;
    };
    addFormador = () => {
        let ativos = [];
        this.edicao.avaliacoes.forEach(a => {
            ativos.push(a.formadorId);
        });
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./add-formadores.dialog.html'),
            controller: ['$scope', '$dialog', 'FormacaoFormador', ($scope, $dialog, FormacaoFormador) => {
                    $scope.hasLoaded = false;
                    $scope.data = {
                        selected: []
                    };
                    FormacaoFormador.find({
                        filter: {
                            where: {
                                active: true,
                                id: {
                                    nin: ativos
                                }
                            }
                        }
                    }).$promise.then(r => {
                        $scope.hasLoaded = true;
                        $scope.formadores = r;
                    });
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                    $scope.ok = () => {
                        $dialog.close($scope.data);
                    };
                }]
        });
        dialog.then(res => {
            if (res) {
                if (res.selected.length > 0) {
                    res.selected.forEach(r => {
                        this.FormacaoEdicaoAvaliacao.create({
                            id: 0,
                            edicaoId: this.ed,
                            formadorId: r.id
                        });
                    });
                    this.loadData();
                    this.UI.addToast('Formadores adicionados com sucesso');
                }
            }
        });
    };
    editEdicao = () => {
        let wait = this.UI.showWaiting();
        this.FormacaoEdicaoRegime.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((regimes) => {
            this.FormacaoModalidade.find({
                filter: {
                    where: {
                        active: 1
                    }
                }
            }).$promise.then((modalidades) => {
                this.FormacaoLocal.find({
                    filter: {
                        where: {
                            active: 1
                        }
                    }
                }).$promise.then((locais) => {
                    this.FormacaoEdicaoEstado.find({}).$promise.then((estados) => {
                        wait.close();
                        let ed = angular.copy(this.edicao);
                        this.UI.showDialog({
                            size: 'lg',
                            template: require('./edit.dialog.html'),
                            controller: ['$scope', ($scope) => {
                                    $scope.regimes = regimes;
                                    $scope.locais = locais;
                                    $scope.estados = estados;
                                    $scope.modalidades = modalidades;
                                    $scope.simnao = this.simnao;
                                    $scope.edicao = {
                                        ano: ed.ano,
                                        no: ed.no,
                                        datainicio: ed.datainicio,
                                        datafim: ed.datafim,
                                        observacoes: ed.observacoes,
                                        tipoId: ed.tipoId,
                                        online: ed.online === 1,
                                        datasExtenso: ed.datasExtenso,
                                        horarioExtenso: ed.horarioExtenso,
                                        localExtenso: ed.localExtenso,
                                        valor: ed.valor,
                                        publicado: ed.publicado
                                    };
                                    $scope.auxLocal = {
                                        selected: ed.local
                                    };
                                    $scope.auxEstado = {
                                        selected: ed.estado
                                    };
                                    $scope.auxModalidade = {
                                        selected: ed.modalidade
                                    };
                                    $scope.auxRegime = {
                                        selected: ed.regime
                                    };
                                    $scope.auxPublicado = {
                                        selected: $scope.simnao.find(x => x.value === ed.publicado)
                                    };
                                    $scope.ok = () => {
                                        $scope.edicao.localId = $scope.auxLocal.selected.id;
                                        $scope.edicao.estadoId = $scope.auxEstado.selected.id;
                                        $scope.edicao.modalidadeId = $scope.auxModalidade.selected.id;
                                        $scope.edicao.regimeId = $scope.auxRegime.selected.id;
                                        $scope.edicao.publicado = $scope.auxPublicado.selected ? $scope.auxPublicado.selected.value : 0;
                                        $scope.$close($scope.edicao);
                                    };
                                    $scope.cancel = () => {
                                        $scope.$dismiss('cancel');
                                    };
                                }]
                        }).then(res => {
                            if (res) {
                                this.hasLoaded = false;
                                this.edicao.ano = res.ano.format('YYYY');
                                this.edicao.no = res.no;
                                this.edicao.datainicio = res.datainicio.format('YYYY-MM-DD');
                                this.edicao.datafim = res.datafim.format('YYYY-MM-DD');
                                this.edicao.observacoes = res.observacoes;
                                this.edicao.online = res.online;
                                this.edicao.estadoId = res.estadoId;
                                this.edicao.datasExtenso = res.datasExtenso;
                                this.edicao.horarioExtenso = res.horarioExtenso;
                                this.edicao.localExtenso = res.localExtenso;
                                this.edicao.publicado = res.publicado;
                                this.edicao.valor = Number(res.valor) || null;
                                if (this.edicao.estado)
                                    this.edicao.estado.id = res.estadoId;
                                this.edicao.localId = res.localId;
                                if (this.edicao.local)
                                    this.edicao.local.id = res.localId;
                                this.edicao.modalidadeId = res.modalidadeId;
                                if (this.edicao.modalidade)
                                    this.edicao.modalidade.id = res.modalidadeId;
                                if (this.edicao.regime)
                                    this.edicao.regime.id = res.regimeId;
                                this.edicao.$save().then(() => {
                                    this.loadData();
                                    this.UI.addToast('Edição editada com sucesso');
                                }).catch((error) => {
                                    console.log(error);
                                    this.hasLoaded = true;
                                    this.UI.addToast('Erro ao editar edição');
                                });
                            }
                        }).catch(() => {
                        });
                    }).catch((error) => {
                        console.log(error);
                        this.UI.addToast("Erro na procura de Estados. Verifique a ligação");
                        wait.close();
                    });
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na procura de Locais de Formação. Verifique a ligação");
                    wait.close();
                });
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Modalidades de Formação. Verifique a ligação");
                wait.close();
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na procura de Regimes de Edição. Verifique a ligação");
            wait.close();
        });
    };
    exportFormandos = () => {
        if (this.edicao.tipoId !== 3) {
            // Check if empresa is filled
        }
        let wait = this.UI.showWaiting();
        this.FormacaoEdicao.exportFormandos({
            id: this.ed
        }).$promise.then((result) => {
            let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + result.fileData;
            let b = document.createElement('a');
            b.href = url;
            b.download = `Formandos_A${("0000000" + this.ed).slice(-7)}.xlsx`;
            b.click();
            wait.close();
        }).catch(() => {
            wait.close();
            this.UI.addToast('Ocorreu um erro ao gerar ficheiro!');
        });
    };
    removeFormador = f => {
        this.UI.showConfirm(`Deseja remover ${f.formador.nome} da lista de formadores atribuídos a esta edição?`).then(res => {
            if (res) {
                // Remove modulos atribuidos ao formador
                this.FormacaoEdicaoLeccionacao.destroyAll({
                    where: {
                        edicaoId: this.ed,
                        formadorId: f.formadorId,
                    }
                }).$promise.then(() => {
                    // Remove formador association with edition
                    this.FormacaoEdicaoAvaliacao.delete(f).$promise.then(() => {
                        this.loadData();
                        this.UI.addToast('Formador removido com sucesso');
                    }).catch(() => {
                        this.UI.addToast('Ocorreu um erro ao remover formador da edição');
                    });
                }).catch(() => {
                    this.UI.addToast('Ocorreu um erro ao remover formador da edição');
                });
            }
        });
    };
    evaluate = f => {
        let c = angular.copy(f);
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./eval-formador.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
                    $scope.data = {
                        desempenho: c.desempenho,
                        avaliacaoGlobal: c.avaliacaoGlobal
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                    $scope.ok = () => {
                        $dialog.close($scope.data);
                    };
                }]
        });
        dialog.then(res => {
            if (res) {
                c.avaliacaoGlobal = res.avaliacaoGlobal || null;
                c.desempenho = res.desempenho || null;
                this.FormacaoEdicaoAvaliacao.upsert(c).$promise.then(() => {
                    this.UI.addToast('Avaliação registada com sucesso');
                    this.loadData();
                }).catch((err) => {
                    this.UI.addToast('Ocorreu um erro ao registar avaliação');
                });
            }
        });
    };
    notaDiscriminada = nota => {
        if (!nota) {
            return "N/D";
        }
        let info = "";
        if (nota <= 25) {
            info = "Muito Fraco";
        }
        else if (nota <= 50) {
            info = "Fraco";
        }
        else if (nota <= 65) {
            info = "Razoável";
        }
        else if (nota <= 80) {
            info = "Bom";
        }
        else {
            info = "Muito Bom";
        }
        return `${nota} (${info})`;
    };
    assignModule = (f) => {
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./assign-module.dialog.html'),
            controller: ['$scope', '$dialog', 'FormacaoModulo', ($scope, $dialog, Modulos) => {
                    $scope.data = {
                        selected: []
                    };
                    $scope.selectAll = () => {
                        $scope.data.selected = [];
                        $scope.modulos.forEach(m => {
                            $scope.data.selected.push(m);
                        });
                    };
                    $scope.hasLoaded = false;
                    // Modulos leccionados
                    let leccionados = [];
                    if (f.formador.leccionacoes.length > 0) {
                        f.formador.leccionacoes.forEach(f => {
                            leccionados.push(f.modulo);
                        });
                    }
                    Modulos.find({
                        filter: {
                            where: {
                                cursoId: this.id
                            }
                        }
                    }).$promise.then(modulos => {
                        modulos.forEach(m => {
                            leccionados.forEach(l => {
                                if (m.id === l.id) {
                                    $scope.data.selected.push(m);
                                }
                            });
                        });
                        $scope.modulos = modulos;
                        $scope.hasLoaded = true;
                    });
                    $scope.ok = () => {
                        if ($scope.hasLoaded)
                            $dialog.close($scope.data);
                        else
                            $dialog.dismiss('cancel');
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        });
        dialog.then(res => {
            // As module assignment only takes in 2/3 modules on average, it's easier to update this way
            // Remove all first
            this.FormacaoEdicaoLeccionacao.destroyAll({
                where: {
                    edicaoId: this.ed,
                    formadorId: f.formadorId,
                }
            }).$promise.then(() => {
                // Insert new ones
                if (res.selected.length > 0) {
                    res.selected.forEach(r => {
                        this.FormacaoEdicaoLeccionacao.create({
                            edicaoId: this.ed,
                            formadorId: f.formadorId,
                            moduloId: r.id
                        }).$promise.then().catch(() => {
                        });
                    });
                }
                this.loadData();
                this.UI.addToast('Atribuição de módulos efetuada com sucesso');
            }).catch(() => {
                this.UI.addToast('Ocorreu um erro ao atualizar lista de atribuição de módulos');
            });
        });
    };
    addFormando = () => {
        let inscricoes = [];
        this.edicao.inscricoes.forEach(i => {
            inscricoes.push(i.formandoId);
        });
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./add-formandos.dialog.html'),
            controller: ['$scope', '$dialog', 'FormacaoFormando', 'FormacaoFormandoEmpresa', 'FormacaoInscricaoEstado', ($scope, $dialog, FormacaoFormando, FormacaoFormandoEmpresa, FormacaoInscricaoEstado) => {
                    // Using to filter by property
                    $scope.prop = "nome";
                    if (this.edicao.tipoId === 1) {
                        // Interna
                        $scope.prop = "name";
                        $scope.nota = "Lista populada por formandos associados ao Grupo IEP.";
                    }
                    else if (this.edicao.tipoId === 2) {
                        // Intra
                        $scope.nota = "Lista populada por formandos associados à empresa.";
                    }
                    else {
                        $scope.nota = "Lista populada por formandos.";
                    }
                    //Infinite Scroll Magic
                    $scope.infiniteScroll = {};
                    $scope.infiniteScroll.numToAdd = 20;
                    $scope.infiniteScroll.currentItems = 20;
                    $scope.addMoreItems = function () {
                        $scope.infiniteScroll.currentItems += $scope.infiniteScroll.numToAdd;
                    };
                    $scope.hasLoaded = false;
                    $scope.data = {
                        selected: [],
                        estado: {
                            selected: undefined
                        }
                    };
                    FormacaoInscricaoEstado.find({}).$promise.then(estados => {
                        $scope.data.estado.selected = estados[1];
                        $scope.estados = estados;
                    });
                    let empresa = {};
                    if (this.edicao.tipoId === 2) {
                        empresa = this.edicao.empresaId;
                    }
                    else {
                        empresa = {
                            inq: [57, 66]
                        };
                    }
                    if (this.edicao.tipoId !== 3) {
                        FormacaoFormandoEmpresa.find({
                            filter: {
                                where: {
                                    active: true,
                                    empresaId: empresa,
                                    formandoId: {
                                        nin: inscricoes
                                    }
                                },
                                include: 'formando',
                            }
                        }).$promise.then((data) => {
                            $scope.formandos = [];
                            data.forEach(d => {
                                d.formando.name = d.formando.nome;
                                $scope.formandos.push(d.formando);
                            });
                            $scope.hasLoaded = true;
                        });
                    }
                    else {
                        FormacaoFormando.find({
                            filter: {
                                where: {
                                    active: true,
                                    id: {
                                        nin: inscricoes
                                    }
                                }
                            }
                        }).$promise.then(formandos => {
                            formandos.forEach(f => {
                                f.name = f.nome;
                            });
                            $scope.formandos = formandos;
                            $scope.hasLoaded = true;
                        });
                    }
                    $scope.hasLoaded = false;
                    $scope.ok = () => {
                        if ($scope.hasLoaded)
                            $dialog.close($scope.data);
                        else
                            $dialog.dismiss('cancel');
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        });
        dialog.then(res => {
            if (res.selected.length > 0) {
                res.selected.forEach(s => {
                    let data = {
                        id: 0,
                        edicaoId: this.ed,
                        estadoId: res.estado.selected.id,
                        dataInscricao: moment().utc(),
                        formandoId: s.id,
                        active: true,
                    };
                    this.FormacaoInscricao.create(data);
                });
                this.loadData();
                this.UI.addToast('Formandos inscritos com sucesso');
            }
        });
    };
    editInscricao = f => {
        let wait = this.UI.showWaiting();
        this.FormacaoInscricaoEstado.find({
            filter: {
                where: {
                    and: [{ id: { neq: f.estadoId } }, { id: { neq: 10 } }]
                }
            }
        }).$promise.then(estados => {
            wait.close();
            let dialog = this.UI.showDialog({
                size: 'lg',
                template: require('./register.dialog.html'),
                controller: ['$scope', '$dialog', ($scope, $dialog) => {
                        $scope.estados = estados;
                        $scope.estado = {
                            selected: undefined
                        };
                        $scope.cancel = () => {
                            $dialog.dismiss('cancel');
                        };
                        $scope.ok = () => {
                            $dialog.close($scope.estado);
                        };
                    }]
            });
            dialog.then(res => {
                if (res.selected) {
                    f.estado = res.selected;
                    f.estadoId = res.selected.id;
                    this.FormacaoInscricao.upsert(f).$promise.then(() => {
                        this.UI.addToast('Estado de inscrição alterado com sucesso');
                        this.loadData();
                    }).catch(() => {
                        this.UI.addToast('Ocorreu um erro ao alterar estado de inscrição');
                    });
                }
            });
        }).catch(error => {
            wait.close();
            console.log(error);
            this.UI.addToast("Erro na obtenção de estados. Verifique a ligação");
        });
    };
    editPreInscricao = f => {
        let wait = this.UI.showWaiting();
        this.FormacaoInscricaoEstado.find({
            filter: {
                where: {
                    id: { neq: f.estadoId }
                }
            }
        }).$promise.then(estados => {
            wait.close();
            let dialog = this.UI.showDialog({
                size: 'lg',
                template: require('./preinscricao.dialog.html'),
                controller: ['$scope', '$dialog', ($scope, $dialog) => {
                        $scope.estados = estados;
                        $scope.nifLoading = false;
                        $scope.estado = {
                            selected: undefined
                        };
                        $scope.formando = {
                            nif: f.formando.nif,
                            nome: f.formando.nome,
                            email: f.formando.email,
                            telefone: f.formando.telefone
                        };
                        $scope.emptyNif = $scope.formando.nif == null || $scope.formando.nif.length === 0;
                        $scope.existingNif = false; // Controls if a NIF exists for this edition
                        $scope.changeNif = () => {
                            if ($scope.formando.nif && $scope.formando.nif.length > 0) {
                                $scope.nifLoading = true;
                                let oldExistingNif = $scope.existingNif; // Save it here in case it errors out we recover it
                                $scope.existingNif = false;
                                this.FormacaoFormando.find({
                                    filter: {
                                        where: {
                                            and: [{ nif: $scope.formando.nif }, { active: 1 }]
                                        }
                                    }
                                }).$promise.then((res) => {
                                    if (res.length === 0) {
                                        // Nothing happens
                                        $scope.nifLoading = false;
                                    }
                                    else {
                                        // Check if it's already subscribed to this edicao
                                        this.FormacaoInscricao.find({
                                            filter: {
                                                where: {
                                                    and: [{ edicaoId: f.edicaoId }, { formandoId: res[0].id }]
                                                }
                                            }
                                        }).$promise.then((ins) => {
                                            if (ins.length === 0) { // Not registered yet
                                                $scope.existingNif = false;
                                                $scope.formandoId = res[0].id;
                                                $scope.formando.nif = res[0].nif;
                                                $scope.formando.nome = res[0].nome;
                                                $scope.formando.email = res[0].email;
                                                $scope.formando.telefone = res[0].telefone;
                                                $scope.nifLoading = false;
                                            }
                                            else { // Already registered, either change or cancel
                                                $scope.existingNif = true;
                                                this.UI.showAlert("NIF já registado para esta edição. Por favor corrija o NIF ou altere o estado da inscrição já existente, ou cancele esta inscrição");
                                                $scope.nifLoading = false;
                                            }
                                        }).catch((error) => {
                                            $scope.existingNif = oldExistingNif;
                                            $scope.nifLoading = false;
                                            console.log(error);
                                            this.UI.addToast("Não foi possível consultar inscrições. Verifique a ligação");
                                        });
                                    }
                                }).catch((error) => {
                                    $scope.nifLoading = false;
                                    $scope.existingNif = oldExistingNif;
                                    console.log(error);
                                    this.UI.addToast("Não foi possível consultar formandos. Verifique a ligação");
                                });
                            }
                            else { // NIF is empty, clear the data
                                $scope.existingNif = false;
                                $scope.formandoId = null;
                                $scope.formando.nome = null;
                                $scope.formando.email = null;
                                $scope.formando.telefone = null;
                            }
                        };
                        // Returns true if OK should be disabled
                        $scope.checkPreInscricao = () => {
                            if ($scope.estado.selected) {
                                if ($scope.estado.selected.id === 3) { // Cancelamento não precisa de nada preenchido
                                    return false;
                                }
                                else {
                                    return $scope.existingNif || $scope.formando.nif == null || $scope.formando.nif.length === 0 ||
                                        $scope.formando.nome == null || $scope.formando.nome.length === 0 ||
                                        $scope.formando.email == null || $scope.formando.email.length === 0 ||
                                        $scope.formando.telefone == null || $scope.formando.telefone.length === 0;
                                }
                            }
                            return true;
                        };
                        $scope.cancel = () => {
                            $dialog.dismiss('cancel');
                        };
                        $scope.ok = () => {
                            $dialog.close($scope);
                        };
                    }]
            });
            dialog.then(ok => {
                if (ok.estado.selected) {
                    let wait = this.UI.showWaiting();
                    this.updateInscricao(f, ok).then(() => {
                        wait.close();
                        this.loadData();
                    }).catch(() => {
                        wait.close();
                        // Do nothing, errors handled inside
                    });
                }
            });
        }).catch(error => {
            wait.close();
            console.log(error);
            this.UI.addToast("Erro na obtenção de estados. Verifique a ligação");
        });
    };
    // Update inscricao f with data from modal - check if inscricao is still ok to change
    updateInscricao = (f, ok) => {
        let defer = this.$q.defer();
        this.FormacaoInscricao.findById({ id: f.id }).$promise.then((inscricao) => {
            if (inscricao) {
                if (inscricao.estadoId === 10) {
                    let formandoId = ok.formandoId || f.formandoId;
                    if (formandoId) {
                        this.FormacaoFormando.findById({ id: formandoId }).$promise.then((formando) => {
                            inscricao.estadoId = ok.estado.selected.id;
                            inscricao.formandoId = formandoId;
                            this.FormacaoInscricao.upsert(inscricao).$promise.then((i) => {
                                if (formando.nif == null || formando.nome !== ok.formando.nome || formando.email !== ok.formando.email || formando.telefone !== ok.formando.telefone) {
                                    // Save changes to Formando, since at least one was changed in the modal
                                    formando.nif = ok.formando.nif; // Assume it's the same except when it's empty
                                    formando.nome = ok.formando.nome;
                                    formando.email = ok.formando.email;
                                    formando.telefone = ok.formando.telefone;
                                    this.FormacaoFormando.upsert(formando).$promise.then(() => {
                                        if (f.formando.nif == null && f.formandoId !== formando.id) { // We need to remove the previous formando (as it's useless now, since it was changed)
                                            this.FormacaoFormando.patch({ id: f.formandoId }, { active: 0 }).$promise.then(() => {
                                                this.UI.addToast("Formando e inscrição atualizados com sucesso");
                                                defer.resolve();
                                            }).catch(error => {
                                                console.log(error);
                                                this.UI.addToast("Formando e inscrição atualizados com sucesso"); // For the user should be transparent the failure to update the formando that should not exist anymore
                                                defer.resolve();
                                            });
                                        }
                                        else {
                                            this.UI.addToast("Formando e inscrição atualizados com sucesso");
                                            defer.resolve();
                                        }
                                    }).catch(error => {
                                        console.log(error);
                                        this.UI.addToast("");
                                    });
                                }
                                else {
                                    this.UI.addToast("Inscrição editada com sucesso");
                                    defer.resolve();
                                }
                            }).catch(error => {
                                console.log(error);
                                this.UI.addToast("Erro na atualização da inscrição. Tente novamente");
                                this.loadData();
                                defer.reject();
                            });
                        }).catch((error) => {
                            console.log(error);
                            this.UI.addToast("Erro na busca de formando. Verifique a ligação");
                            defer.reject();
                        });
                    }
                    else {
                        this.UI.addToast("Erro na definição de formando. Tente novamente");
                        defer.reject();
                    }
                }
                else {
                    this.UI.addToast("Inscrição já tinha sido processada.");
                    this.loadData();
                    defer.reject();
                }
            }
            else {
                this.UI.addToast("Inscrição não encontrada. Verifique se ainda existe.");
                this.loadData();
                defer.reject();
            }
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na busca de Inscrição. Recarregue a página");
            defer.reject();
        });
        return defer.promise;
    };
    removeFormando = f => {
        this.UI.showConfirm(`Deseja remover ${f.formando.nome} da lista de formandos inscritos a esta edição?`).then(res => {
            if (res) {
                this.FormacaoInscricao.delete(f).$promise.then(() => {
                    this.UI.addToast('Inscrição removida com sucesso');
                    this.loadData();
                }).catch(() => {
                    this.UI.addToast('Ocorreu um erro ao remover inscrição');
                });
            }
        });
    };
    // Anexos
    addAnexo = () => {
        let options = {
            size: 'lg',
            controller: 'FormacaoEdicaoFileUploaderController',
            controllerAs: 'm',
            template: require('./files.dialog.html'),
            resolve: {
                pID: () => {
                    return this.edicao.id;
                },
                file: () => {
                    return undefined;
                }
            }
        };
        let dialog = this.UI.showDialog(options);
        dialog.then(res => {
            if (res) {
                this.loadData();
                this.UI.addToast('Ficheiro carregado com sucesso');
            }
        });
    };
    editAnexo = (f) => {
        let options = {
            size: 'lg',
            controller: 'FormacaoEdicaoFileUploaderController',
            controllerAs: 'm',
            template: require('./files.dialog.html'),
            resolve: {
                pID: () => {
                    return this.edicao.id;
                },
                file: () => {
                    return f.info;
                }
            }
        };
        let dialog = this.UI.showDialog(options);
        dialog.then(res => {
            if (res) {
                this.loadData();
                this.UI.addToast('Ficheiro carregado com sucesso');
            }
        });
    };
    removeAnexo = (file) => {
        let confirm = this.UI.showConfirm('Deseja remover o ficheiro?');
        confirm.then(res => {
            if (res) {
                file.info.active = 0;
                this.FormacaoEdicaoAnexo.upsert(file.info).$promise.then(() => {
                    this.loadData();
                    this.UI.addToast('Ficheiro removido');
                });
            }
        });
    };
    // Format bytes into correct units
    formatBytes = (bytes, decimals) => {
        if (bytes == null)
            return "N/D";
        if (bytes === 0)
            return '0 Bytes';
        let k = 1024, dm = decimals <= 0 ? 0 : decimals || 2, sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };
    showVisibilidadeEdicao = () => {
        if (this.edicao && this.edicao.curso) {
            if (this.edicao.publicado) {
                if (this.edicao.curso.publicado) {
                    return 'Sim';
                }
                else {
                    return 'Sim (Curso não publicado)';
                }
            }
            else {
                return 'Não';
            }
        }
        return 'N/D';
    };
    // Usado para quando não há nenhum formando numa destas situações (layout apenas)
    estadoInscricaoStringLayout = () => {
        switch (this.inscritosEstado) {
            case 1:
                return 'confirmado';
            case 2:
                return 'inscrito';
            case 3:
                return 'com inscrição cancelada';
            case 10:
                return 'pré-inscrito';
        }
        return '';
    };
    // Ver detalhes de informação de pagamento para formando
    verInfoPagamento = (inscricao) => {
        // If necessary, add more documento types
        if (!inscricao || !inscricao.pagamento) {
            this.UI.addToast("Sem informação de pagamento disponível");
            return;
        }
        let options = {
            size: "lg",
            template: require("./info.pagamento.dialog.html"),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Detalhes de Pagamento - " + inscricao.formando.nome;
                    $scope.pagamento = inscricao.pagamento;
                    $scope.ok = () => {
                        $dialog.close();
                    };
                }]
        };
        let dialog = this.UI.showDialog(options);
        dialog.then((ok) => {
            // Do nothing
        }).catch(() => { });
    };
    // Ver detalhes de informação de pagamento para formando
    verInfoEmpresa = (inscricao) => {
        // If necessary, add more documento types
        if (!inscricao || !inscricao.inscricaoEmpresa) {
            this.UI.addToast("Sem informação de inscrição de empresa disponível");
            return;
        }
        let options = {
            size: "lg",
            template: require("./info.empresa.dialog.html"),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Detalhes de Inscrição de Empresa - " + inscricao.inscricaoEmpresa.empresa.designacao;
                    $scope.inscricaoEmpresa = inscricao.inscricaoEmpresa;
                    $scope.ok = () => {
                        $dialog.close();
                    };
                }]
        };
        let dialog = this.UI.showDialog(options);
        dialog.then((ok) => {
            // Do nothing
        }).catch(() => { });
    };
    editSlug = () => {
        let options = {
            size: "lg",
            template: require("./edit.slug.html"),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.slug = this.edicao.slug;
                    $scope.checkingSlug = false;
                    $scope.isValidSlug = () => {
                        if (typeof $scope.slug !== "string")
                            return false;
                        // WordPress-like: a-z, 0-9, separated by single hyphens
                        // - no leading/trailing hyphen
                        // - no consecutive hyphens
                        // - no uppercase, accents, underscores, spaces, etc.
                        return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test($scope.slug);
                    };
                    $scope.ok = () => {
                        $scope.checkingSlug = true;
                        this.FormacaoService.checkExistingSlug($scope.slug, this.edicao.id).then((exists) => {
                            $scope.checkingSlug = false;
                            if (exists) {
                                this.UI.addToast("Este slug já existe para outra edição");
                            }
                            else {
                                $dialog.close($scope);
                            }
                        }).catch(err => {
                            $scope.checkingSlug = false;
                            this.UI.addToast("Erro de verificação de slug. Verifique a ligação");
                            console.log(err);
                        });
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        };
        let dialog = this.UI.showDialog(options);
        dialog.then((ok) => {
            this.FormacaoEdicao.prototype$updateAttributes({ id: this.edicao.id }, { slug: ok.slug }).$promise.then(() => {
                this.UI.addToast('Slug alterada com sucesso');
                this.loadData();
            }).catch(() => {
                this.UI.addToast('Erro ao alterar slug. Verifique a ligação');
                this.loadData();
            });
        }).catch(() => { });
    };
}
FormacaoCursoEdicaoController
    .$inject = ['$q', '$state', '$http', 'UIService', 'FormacaoService', 'FormacaoEdicao', 'FormacaoEdicaoAvaliacao', 'FormacaoInscricao', 'FormacaoEdicaoLeccionacao', 'FormacaoLocal', 'FormacaoEdicaoEstado', 'FormacaoModalidade', 'FormacaoEdicaoAnexo', 'FormacaoEdicaoRegime', 'FormacaoInscricaoEstado', 'FormacaoFormando'];
